import { useQuery } from '@tanstack/react-query'
import { api } from './api'
import { useAuth } from './auth'

interface CapabilitiesResponse { ok: boolean; capabilities: string[] }

/* Mirrors home_bp's capability-driven action model on the React side: the
 * backend resolves the caller's capability keys (role_service.CAPABILITIES)
 * from their role - built-in or custom, via the Role Builder - and the UI
 * shows only the actions each key unlocks. */
export function useCapabilities(): Set<string> {
  const { user } = useAuth()
  const { data } = useQuery({
    queryKey: ['capabilities'],
    queryFn: () => api.get<CapabilitiesResponse>('/capabilities'),
    enabled: !!user,
    staleTime: 5 * 60_000,
  })
  return new Set(data?.capabilities ?? [])
}
